import React, { forwardRef } from "react"
import MenuButton from '../Buttons/MenuButton'

const MenuItem = forwardRef(({ children, ...props }, ref) => {

  return (
    <MenuButton ref={ref} {...props}>{children}</MenuButton>
  )
})

export default MenuItem